var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',[_c('li',[_c('p',[_vm._v("1. Клиент должен установить приложение.")]),_c('img',{staticStyle:{"width":"500px"},attrs:{"src":"/img/trueConf/a2.png","alt":""}})]),_c('li',[_vm._v("2. Все остальные инструкции, клиент получит от Агента")])])])
}]

export { render, staticRenderFns }